import { control } from '@reactables/forms';

export const eventType = control([null, 'required']);
